// // import React, { useEffect, useState } from "react";
// // import AdminComments from "../common/AdminComments";
// // import { useSelector } from "react-redux";
// // import { getChatNotifications } from "../../services/admin.services";
// // import { MarkSideBarChatNotifications } from "../../services/user.services";
// // import { useLocation } from "react-router-dom";
// // import { FaChevronDown, FaFilter } from "react-icons/fa";

// // function CommentsSection({ messages, setMessages, queryOnFromState }) {
// //   const location = useLocation();
// //   const [activeTab, setActiveTab] = useState("CV Upload");
// //   const [socket, setSocket] = useState(null);
// //   const [comments, setComments] = useState({});
// //   const [currentRoom, setCurrentRoom] = useState("");
// //   const [showMobileDropdown, setShowMobileDropdown] = useState(false);
// //   const [showAllCategories, setShowAllCategories] = useState(false);
// //   const selectedStudent = useSelector((state) => state.app.selectedStudent);
// //   const user_id = useSelector((state) => state.user.user_id);
// //   const user = useSelector((state) => state.user.userDetails);
// //   const userRole = user?.role || "admin"; // Default to admin if role not found
// //   const [categories, setCategories] = useState([
// //     { name: "CV Upload", title: "cv_upload" },
// //     { name: "Shortlisting", title: "shortlisting_of_universities" },
// //     { name: "SOP", title: "sop" },
// //     { name: "LOR", title: "lor" },
// //     {
// //       name: "UG Only",
// //       title: "ug_only",
// //     },
// //     {
// //       name: "University Specific SOP/Essays",
// //       title: "university_specific_sop",
// //     },
// //     {
// //       name: "Final Documents Upload",
// //       title: "final_documents_upload",
// //     },
// //     {
// //       name: "University Application Process",
// //       title: "university_application_process",
// //     },
// //     { name: "Visa Process", title: "visa_process" },
// //   ]);

// //   const getNotifications = async () => {
// //     try {
// //       const res = await getChatNotifications();
// //       // ✅ FIX: Access the notifications array from the response
// //       const notifications = res.data?.notifications || [];
// //       setMessages(notifications);
// //     } catch (err) {
// //       console.error("Error fetching notifications:", err);
// //       setMessages([]); // ✅ Set empty array on error
// //     }
// //   };

// //   useEffect(() => {
// //     getNotifications();
// //   }, []);

// //   useEffect(() => {
// //     let intervalId;

// //     if (user && userRole) {
// //       // Initial fetch
// //       getNotifications();

// //       // Set up polling every 30 seconds (adjust as needed)
// //       intervalId = setInterval(() => {
// //         getNotifications();
// //       }, 10000); // 30000ms = 30 seconds
// //     }

// //     // Clear interval on component unmount
// //     return () => {
// //       if (intervalId) {
// //         clearInterval(intervalId);
// //       }
// //     };
// //   }, [user, userRole]);

// //   const markNotificationsAsRead = async (title) => {
// //     try {
// //       // First check if there are any unread notifications for this title
// //       const hasUnreadNotifications = messages.some(
// //         (msg) => msg.query_on === title && !msg.is_read
// //       );

// //       if (hasUnreadNotifications) {
// //         // Call the service to mark notifications as read
// //         const response = await MarkSideBarChatNotifications();

// //         if (response) {
// //           // Update local state to reflect read status
// //           setMessages((prevMessages) =>
// //             prevMessages.map((msg) =>
// //               msg.query_on === title ? { ...msg, is_read: true } : msg
// //             )
// //           );
// //         }
// //       }
// //     } catch (error) {
// //       console.error("Error marking notifications as read:", error);
// //     }
// //   };

// //   useEffect(() => {
// //     console.log("queryOnFromState:", queryOnFromState);
// //     console.log("categories length:", categories.length);

// //     if (queryOnFromState && categories.length > 0) {
// //       const category = categories.find((cat) => cat.title === queryOnFromState);
// //       console.log("Found category:", category);

// //       if (category) {
// //         console.log("Setting active tab to:", category.name);
// //         setActiveTab(category.name);
// //         markNotificationsAsRead(category.title);

// //         // Clear browser state so tab isn't re-triggered again
// //         if (window.history.replaceState) {
// //           window.history.replaceState({}, document.title);
// //         }
// //       } else {
// //         console.log(
// //           "Category not found for queryOnFromState:",
// //           queryOnFromState
// //         );
// //       }
// //     }
// //   }, [queryOnFromState, categories.length]);

// //   // Function to count unread messages per category
// //   const getUnreadCount = (categoryTitle) => {
// //     return messages.filter(
// //       (msg) => msg.query_on === categoryTitle && !msg.is_read
// //     ).length;
// //   };

// //   // Function to render content based on the active tab
// //   const renderContent = () => {
// //     return (
// //       <AdminComments
// //         activeTab={categories.find((item) => item.name === activeTab)}
// //       />
// //     );
// //   };

// //   // Get current active category
// //   const currentCategory = categories.find((cat) => cat.name === activeTab);
// //   const currentUnreadCount = getUnreadCount(currentCategory?.title);

// //   // Handle category selection
// //   const handleCategorySelect = (category) => {
// //     setActiveTab(category.name);
// //     markNotificationsAsRead(category.title);
// //     setShowMobileDropdown(false);
// //   };

// //   // Display categories based on screen size and state
// //   const displayCategories = showAllCategories
// //     ? categories
// //     : categories.slice(0, 4);

// //   return (
// //     <div>
// //       <div className="p-2 sm:p-4">
// //         {/* Mobile Dropdown Categories (visible on small screens) */}
// //         <div className="block sm:hidden mb-4">
// //           <div className="relative">
// //             <button
// //               onClick={() => setShowMobileDropdown(!showMobileDropdown)}
// //               className="w-full flex items-center justify-between px-4 py-3 bg-white border border-gray-200 rounded-lg shadow-sm"
// //             >
// //               <div className="flex items-center">
// //                 <FaFilter className="mr-2 text-gray-500" />
// //                 <span className="font-medium text-gray-700 truncate">
// //                   {activeTab}
// //                 </span>
// //                 {currentUnreadCount > 0 && (
// //                   <span className="ml-2 bg-red-500 text-white rounded-full w-5 h-5 inline-flex items-center justify-center text-xs flex-shrink-0">
// //                     {currentUnreadCount}
// //                   </span>
// //                 )}
// //               </div>
// //               <FaChevronDown
// //                 className={`transition-transform duration-200 flex-shrink-0 ml-2 ${
// //                   showMobileDropdown ? "rotate-180" : ""
// //                 }`}
// //               />
// //             </button>

// //             {/* Mobile Dropdown Menu */}
// //             {showMobileDropdown && (
// //               <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-64 overflow-y-auto">
// //                 {categories.map((category) => {
// //                   const unreadCount = getUnreadCount(category.title);
// //                   return (
// //                     <button
// //                       key={category.name}
// //                       onClick={() => handleCategorySelect(category)}
// //                       className={`
// //                         w-full flex items-center justify-between px-4 py-3 text-left border-b border-gray-100 last:border-b-0
// //                         ${
// //                           activeTab === category.name
// //                             ? "bg-blue-50 text-blue-600"
// //                             : "text-gray-700 hover:bg-gray-50"
// //                         }
// //                       `}
// //                     >
// //                       <span className="font-medium truncate">
// //                         {category.name}
// //                       </span>
// //                       {unreadCount > 0 && (
// //                         <span className="bg-red-500 text-white rounded-full w-5 h-5 inline-flex items-center justify-center text-xs flex-shrink-0">
// //                           {unreadCount}
// //                         </span>
// //                       )}
// //                     </button>
// //                   );
// //                 })}
// //               </div>
// //             )}
// //           </div>
// //         </div>

// //         {/* Desktop/Tablet Categories Section (hidden on small screens) */}
// //         <div className="hidden sm:block mb-4 border-b border-gray-200 pb-4">
// //           <h3 className="text-gray-700 font-semibold mb-2">Categories:</h3>

// //           {/* Original horizontal scroll design */}
// //           <div className="flex overflow-x-auto hide-scrollbar">
// //             {categories.map((category) => {
// //               const unreadCount = getUnreadCount(category.title);
// //               return (
// //                 <button
// //                   key={category.name}
// //                   className={`px-4 py-2 whitespace-nowrap mr-2 font-medium rounded-md transition-colors ${
// //                     activeTab === category.name
// //                       ? "bg-blue-500 text-white"
// //                       : "bg-gray-100 text-gray-600 hover:bg-gray-200"
// //                   }`}
// //                   onClick={() => handleCategorySelect(category)}
// //                 >
// //                   {category.name}
// //                   {unreadCount > 0 && (
// //                     <span className="ml-2 bg-red-500 text-white rounded-full w-5 h-5 inline-flex items-center justify-center text-xs">
// //                       {unreadCount}
// //                     </span>
// //                   )}
// //                 </button>
// //               );
// //             })}
// //           </div>
// //         </div>

// //         {/* Dynamic Content Section */}
// //         <div className="bg-blue-50 rounded-lg min-h-[400px] sm:min-h-[600px] shadow-md p-3 sm:p-4 overflow-auto">
// //           {renderContent()}
// //         </div>
// //       </div>

// //       {/* Overlay to close mobile dropdown when clicking outside */}
// //       {showMobileDropdown && (
// //         <div
// //           className="fixed inset-0 z-40 sm:hidden"
// //           onClick={() => setShowMobileDropdown(false)}
// //         />
// //       )}
// //     </div>
// //   );
// // }

// // export default CommentsSection;
// import React, { useEffect, useState } from "react";
// import AdminComments from "../common/AdminComments";
// import { useSelector } from "react-redux";
// import { getChatNotifications } from "../../services/admin.services";
// import { MarkSideBarChatNotifications } from "../../services/user.services";
// import { useLocation } from "react-router-dom";
// import { FaChevronDown, FaFilter } from "react-icons/fa";
// import { useRef } from "react";

// function CommentsSection({ messages, setMessages, queryOnFromState }) {
//   const location = useLocation();
//   const [activeTab, setActiveTab] = useState("CV Upload");
//   const [socket, setSocket] = useState(null);
//   const [comments, setComments] = useState({});
//   const [currentRoom, setCurrentRoom] = useState("");
//   const [showMobileDropdown, setShowMobileDropdown] = useState(false);
//   const [showAllCategories, setShowAllCategories] = useState(false);
//   const categoriesWrapperRef = useRef(null);
//   const [categoryWidth, setCategoryWidth] = useState(0);

//   const selectedStudent = useSelector((state) => state.app.selectedStudent);
//   const user_id = useSelector((state) => state.user.user_id);
//   const user = useSelector((state) => state.user.userDetails);
//   const userRole = user?.role || "admin"; // Default to admin if role not found
//   const [categories, setCategories] = useState([
//     { name: "CV Upload", title: "cv_upload" },
//     { name: "Shortlisting", title: "shortlisting_of_universities" },
//     { name: "SOP", title: "sop" },
//     { name: "LOR", title: "lor" },
//     {
//       name: "UG Only",
//       title: "ug_only",
//     },
//     {
//       name: "University Specific SOP/Essays",
//       title: "university_specific_sop",
//     },
//     {
//       name: "Final Documents Upload",
//       title: "final_documents_upload",
//     },
//     {
//       name: "University Application Process",
//       title: "university_application_process",
//     },
//     { name: "Visa Process", title: "visa_process" },
//   ]);

//   // useEffect(() => {
//   //   const calculateWidth = () => {
//   //     if (!categoriesWrapperRef.current) return;

//   //     const parentWidth = categoriesWrapperRef.current.offsetWidth;

//   //     // // How many categories should be visible without scroll
//   //     // const visibleCount = 4;

//   //     // // Gap between buttons (Tailwind gap-2 = 8px)
//   //     // const gap = 8;

//   //     // const totalGap = gap * (visibleCount - 1);
//   //     // const availableWidth = parentWidth - totalGap;

//   //     // const calculatedWidth = Math.floor(availableWidth / visibleCount);

//   //     // // Clamp width (important)
//   //     // setCategoryWidth(Math.max(140, Math.min(calculatedWidth, 260)));
//   //     setCategoryWidth(parentWidth);
//   //   };

//   //   calculateWidth();
//   //   window.addEventListener("resize", calculateWidth);

//   //   return () => window.removeEventListener("resize", calculateWidth);
//   // }, []);
//   useEffect(() => {
//     const calculateWidth = () => {
//       if (!categoriesWrapperRef.current) return;

//       const parentWidth = categoriesWrapperRef.current.offsetWidth;

//       const subtractPx = 100; // 👈 whatever you want to subtract
//       setCategoryWidth(parentWidth - subtractPx);
//     };

//     calculateWidth();
//     window.addEventListener("resize", calculateWidth);
//     return () => window.removeEventListener("resize", calculateWidth);
//   }, []);

//   const getNotifications = async () => {
//     try {
//       const res = await getChatNotifications();
//       // ✅ FIX: Access the notifications array from the response
//       const notifications = res.data?.notifications || [];
//       setMessages(notifications);
//     } catch (err) {
//       console.error("Error fetching notifications:", err);
//       setMessages([]); // ✅ Set empty array on error
//     }
//   };

//   useEffect(() => {
//     getNotifications();
//   }, []);

//   useEffect(() => {
//     let intervalId;

//     if (user && userRole) {
//       // Initial fetch
//       getNotifications();

//       // Set up polling every 30 seconds (adjust as needed)
//       intervalId = setInterval(() => {
//         getNotifications();
//       }, 10000); // 30000ms = 30 seconds
//     }

//     // Clear interval on component unmount
//     return () => {
//       if (intervalId) {
//         clearInterval(intervalId);
//       }
//     };
//   }, [user, userRole]);

//   const markNotificationsAsRead = async (title) => {
//     try {
//       // First check if there are any unread notifications for this title
//       const hasUnreadNotifications = messages.some(
//         (msg) => msg.query_on === title && !msg.is_read
//       );

//       if (hasUnreadNotifications) {
//         // Call the service to mark notifications as read
//         const response = await MarkSideBarChatNotifications();

//         if (response) {
//           // Update local state to reflect read status
//           setMessages((prevMessages) =>
//             prevMessages.map((msg) =>
//               msg.query_on === title ? { ...msg, is_read: true } : msg
//             )
//           );
//         }
//       }
//     } catch (error) {
//       console.error("Error marking notifications as read:", error);
//     }
//   };

//   useEffect(() => {
//     console.log("queryOnFromState:", queryOnFromState);
//     console.log("categories length:", categories.length);

//     if (queryOnFromState && categories.length > 0) {
//       const category = categories.find((cat) => cat.title === queryOnFromState);
//       console.log("Found category:", category);

//       if (category) {
//         console.log("Setting active tab to:", category.name);
//         setActiveTab(category.name);
//         markNotificationsAsRead(category.title);

//         // Clear browser state so tab isn't re-triggered again
//         if (window.history.replaceState) {
//           window.history.replaceState({}, document.title);
//         }
//       } else {
//         console.log(
//           "Category not found for queryOnFromState:",
//           queryOnFromState
//         );
//       }
//     }
//   }, [queryOnFromState, categories.length]);

//   // Function to count unread messages per category
//   const getUnreadCount = (categoryTitle) => {
//     return messages.filter(
//       (msg) => msg.query_on === categoryTitle && !msg.is_read
//     ).length;
//   };

//   // Function to render content based on the active tab
//   const renderContent = () => {
//     return (
//       <AdminComments
//         activeTab={categories.find((item) => item.name === activeTab)}
//       />
//     );
//   };

//   // Get current active category
//   const currentCategory = categories.find((cat) => cat.name === activeTab);
//   const currentUnreadCount = getUnreadCount(currentCategory?.title);

//   // Handle category selection
//   const handleCategorySelect = (category) => {
//     setActiveTab(category.name);
//     markNotificationsAsRead(category.title);
//     setShowMobileDropdown(false);
//   };

//   // Display categories based on screen size and state
//   const displayCategories = showAllCategories
//     ? categories
//     : categories.slice(0, 4);

//   return (
//     <div
//       ref={categoriesWrapperRef}
//       className="w-full max-w-full overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 pb-2 -mb-2"
//     >
//       <div className="flex-1 flex flex-col w-full max-w-full p-2 sm:p-3 md:p-4 lg:p-5 overflow-hidden">
//         {/* Mobile Dropdown Categories (visible on small screens) */}
//         <div className="block sm:hidden mb-3 flex-shrink-0 w-full">
//           <div className="relative w-full">
//             <button
//               onClick={() => setShowMobileDropdown(!showMobileDropdown)}
//               className="w-full flex items-center justify-between px-3 py-2.5 bg-white border border-gray-200 rounded-lg shadow-sm min-w-0"
//             >
//               <div className="flex items-center min-w-0 flex-1 mr-2">
//                 <FaFilter className="mr-2 text-gray-500 flex-shrink-0 text-sm" />
//                 <span className="font-medium text-gray-700 truncate text-sm">
//                   {activeTab}
//                 </span>
//                 {currentUnreadCount > 0 && (
//                   <span className="ml-2 bg-red-500 text-white rounded-full min-w-[20px] h-5 px-1.5 inline-flex items-center justify-center text-xs flex-shrink-0">
//                     {currentUnreadCount}
//                   </span>
//                 )}
//               </div>
//               <FaChevronDown
//                 className={`transition-transform duration-200 flex-shrink-0 text-sm ${
//                   showMobileDropdown ? "rotate-180" : ""
//                 }`}
//               />
//             </button>

//             {/* Mobile Dropdown Menu */}
//             {showMobileDropdown && (
//               <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-64 overflow-y-auto">
//                 {categories.map((category) => {
//                   const unreadCount = getUnreadCount(category.title);
//                   return (
//                     <button
//                       key={category.name}
//                       onClick={() => handleCategorySelect(category)}
//                       className={`
//                         w-full flex items-center justify-between px-3 py-2.5 text-left border-b border-gray-100 last:border-b-0 min-w-0
//                         ${
//                           activeTab === category.name
//                             ? "bg-blue-50 text-blue-600"
//                             : "text-gray-700 hover:bg-gray-50"
//                         }
//                       `}
//                     >
//                       <span className="font-medium truncate text-sm flex-1 min-w-0 mr-2">
//                         {category.name}
//                       </span>
//                       {unreadCount > 0 && (
//                         <span className="bg-red-500 text-white rounded-full min-w-[20px] h-5 px-1.5 inline-flex items-center justify-center text-xs flex-shrink-0">
//                           {unreadCount}
//                         </span>
//                       )}
//                     </button>
//                   );
//                 })}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Desktop/Tablet Categories Section (hidden on small screens) */}
//         <div
//           className="hidden sm:block mb-3 md:mb-4 border-b border-gray-200 pb-3 flex-shrink-0"
//           style={{ width: `${categoryWidth}px` }}
//         >
//           <h3 className="text-gray-700 font-semibold mb-2 text-sm md:text-base px-1">
//             Categories:
//           </h3>

//           {/* Horizontal scroll design with proper overflow handling */}
//           <div className="w-full max-w-full overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 pb-2 -mb-2">
//             <div className="flex gap-2 w-full pr-4">
//               {categories.map((category) => {
//                 const unreadCount = getUnreadCount(category.title);
//                 return (
//                   <button
//                     key={category.name}
//                     className={`px-3 md:px-4 py-2 whitespace-nowrap font-medium rounded-md transition-colors flex-shrink-0 text-xs sm:text-sm md:text-base flex items-center gap-2 ${
//                       activeTab === category.name
//                         ? "bg-blue-500 text-white shadow-md"
//                         : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//                     }`}
//                     onClick={() => handleCategorySelect(category)}
//                   >
//                     <span className="truncate max-w-[150px] sm:max-w-[180px] md:max-w-[220px]">
//                       {category.name}
//                     </span>
//                     {unreadCount > 0 && (
//                       <span className="bg-red-500 text-white rounded-full min-w-[18px] h-5 px-1.5 inline-flex items-center justify-center text-xs flex-shrink-0 font-semibold">
//                         {unreadCount}
//                       </span>
//                     )}
//                   </button>
//                 );
//               })}
//             </div>
//           </div>
//         </div>

//         {/* Dynamic Content Section - Takes remaining space */}
//         <div className="flex-1 bg-blue-50 rounded-lg shadow-md overflow-hidden flex flex-col w-full max-w-full">
//           <div className="flex-1 overflow-auto p-3 sm:p-4 md:p-5 w-full max-w-full">
//             {renderContent()}
//           </div>
//         </div>
//       </div>

//       {/* Overlay to close mobile dropdown when clicking outside */}
//       {showMobileDropdown && (
//         <div
//           className="fixed inset-0 z-40 sm:hidden bg-black bg-opacity-20"
//           onClick={() => setShowMobileDropdown(false)}
//         />
//       )}

//       <style jsx>{`
//         /* Hide scrollbar for Chrome, Safari and Opera */
//         .hide-scrollbar::-webkit-scrollbar {
//           display: none;
//         }

//         /* Hide scrollbar for IE, Edge and Firefox */
//         .hide-scrollbar {
//           -ms-overflow-style: none; /* IE and Edge */
//           scrollbar-width: none; /* Firefox */
//         }

//         /* Custom scrollbar for horizontal scroll */
//         .scrollbar-thin::-webkit-scrollbar {
//           height: 6px;
//         }

//         .scrollbar-thin::-webkit-scrollbar-track {
//           background: #f1f1f1;
//           border-radius: 10px;
//         }

//         .scrollbar-thin::-webkit-scrollbar-thumb {
//           background: #d1d5db;
//           border-radius: 10px;
//         }

//         .scrollbar-thin::-webkit-scrollbar-thumb:hover {
//           background: #9ca3af;
//         }

//         /* Firefox scrollbar */
//         .scrollbar-thin {
//           scrollbar-width: thin;
//           scrollbar-color: #d1d5db #f1f1f1;
//         }
//       `}</style>
//     </div>
//   );
// }

// export default CommentsSection;
import React, { useEffect, useState } from "react";
import AdminComments from "../common/AdminComments";
import { useSelector } from "react-redux";
import { getChatNotifications } from "../../services/admin.services";
import { MarkSideBarChatNotifications } from "../../services/user.services";
import { useLocation } from "react-router-dom";
import { FaChevronDown, FaFilter } from "react-icons/fa";

function CommentsSection({ messages, setMessages, queryOnFromState }) {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("CV Upload");
  const [socket, setSocket] = useState(null);
  const [comments, setComments] = useState({});
  const [currentRoom, setCurrentRoom] = useState("");
  const [showMobileDropdown, setShowMobileDropdown] = useState(false);
  const [showAllCategories, setShowAllCategories] = useState(false);
  const selectedStudent = useSelector((state) => state.app.selectedStudent);
  const user_id = useSelector((state) => state.user.user_id);
  const user = useSelector((state) => state.user.userDetails);
  const userRole = user?.role || "admin"; // Default to admin if role not found

  const CATEGORY_TO_QUERY_ON = {
    cv_upload: "cv",
    shortlisting_of_universities: "shortlisting",
    sop: "sop",
    lor: "lor",
    ug_only: "ug",
    university_specific_sop: "university_specific_sop",
    final_documents_upload: "final_documents_upload",
    university_application_process: "university_application_process",
    visa_process: "visa_process",
  };

  const [categories, setCategories] = useState([
    { name: "CV Upload", title: "cv_upload" },
    { name: "Shortlisting", title: "shortlisting_of_universities" },
    { name: "SOP", title: "sop" },
    { name: "LOR", title: "lor" },
    {
      name: "UG Only",
      title: "ug_only",
    },
    {
      name: "University Specific SOP/Essays",
      title: "university_specific_sop",
    },
    {
      name: "Final Documents Upload",
      title: "final_documents_upload",
    },
    {
      name: "University Application Process",
      title: "university_application_process",
    },
    { name: "Visa Process", title: "visa_process" },
  ]);

  // const getNotifications = async () => {
  //   try {
  //     const res = await getChatNotifications();
  //     setMessages(res.data?.notifications);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const getNotifications = async () => {
    try {
      const res = await getChatNotifications();
      setMessages(res.data?.notifications || []); // ✅ always array
    } catch (err) {
      console.log(err);
      setMessages([]); // ✅ fallback
    }
  };

  const isUnread = (m) =>
    m?.is_read === false || m?.is_read === 0 || m?.is_read === "false";

  const normalizeKey = (categoryTitle) =>
    (CATEGORY_TO_QUERY_ON[categoryTitle] || categoryTitle || "")
      .toLowerCase()
      .trim();

  const getUnreadCount = (categoryTitle) => {
    const key = normalizeKey(categoryTitle);

    return (messages || []).filter((m) => {
      const q = (m?.query_on || "").toLowerCase().trim();
      return q === key && isUnread(m);
    }).length;
  };

  useEffect(() => {
    getNotifications();
  }, []);

  useEffect(() => {
    let intervalId;

    if (user && userRole) {
      // Initial fetch
      getNotifications();

      // Set up polling every 30 seconds (adjust as needed)
      intervalId = setInterval(() => {
        getNotifications();
      }, 10000); // 30000ms = 30 seconds
    }

    // Clear interval on component unmount
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [user, userRole]);

  // const markNotificationsAsRead = async (title) => {
  //   try {
  //     // First check if there are any unread notifications for this title
  //     const hasUnreadNotifications = messages.some(
  //       (msg) => msg.query_on === title && !msg.is_read
  //     );

  //     if (hasUnreadNotifications) {
  //       // Call the service to mark notifications as read
  //       const response = await MarkSideBarChatNotifications();

  //       if (response) {
  //         // Update local state to reflect read status
  //         setMessages((prevMessages) =>
  //           prevMessages.map((msg) =>
  //             msg.query_on === title ? { ...msg, is_read: true } : msg
  //           )
  //         );
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error marking notifications as read:", error);
  //   }
  // };
  // const isUnread = (m) =>
  //   m.is_read === false || m.is_read === 0 || m.is_read === "false";

  // const normalizeKey = (categoryTitle) =>
  //   (CATEGORY_TO_QUERY_ON[categoryTitle] || categoryTitle || "")
  //     .toLowerCase()
  //     .trim();
  const markNotificationsAsRead = async (categoryTitle) => {
    try {
      const key = normalizeKey(categoryTitle);

      const unread = (messages || []).filter((m) => {
        const q = (m.query_on || "").toLowerCase().trim();
        return q === key && isUnread(m);
      });

      if (unread.length === 0) return;

      const roomNames = [
        ...new Set(unread.map((m) => m.roomname).filter(Boolean)),
      ];

      await Promise.all(
        roomNames.map((room) =>
          MarkSideBarChatNotifications({ mark_all: true, room_name: room })
        )
      );

      const unreadIds = new Set(unread.map((m) => m.id));
      setMessages((prev) =>
        prev.map((m) => (unreadIds.has(m.id) ? { ...m, is_read: true } : m))
      );
    } catch (e) {
      console.error("Mark read failed:", e?.response?.data || e);
    }
  };
  const QUERYON_TO_CATEGORY = {
    cv: "cv_upload",
    shortlisting: "shortlisting_of_universities",
    sop: "sop",
    lor: "lor",
    ug: "ug_only",
    university: "university_specific_sop", // adjust if needed
    final_documents_upload: "final_documents_upload",
    university_application_process: "university_application_process",
    visa_process: "visa_process",
  };

  useEffect(() => {
    const raw = queryOnFromState;
    const q = typeof raw === "string" ? raw : raw?.queryOn; // in case you pass object later

    const key = (q || "").toLowerCase().trim();
    if (!key) return;

    const mappedTitle = QUERYON_TO_CATEGORY[key] || key;

    const category = categories.find(
      (cat) => cat.title.toLowerCase().trim() === mappedTitle
    );

    console.log(
      "queryOnFromState:",
      key,
      "mappedTitle:",
      mappedTitle,
      "category:",
      category
    );

    if (category) {
      setActiveTab(category.name);
      markNotificationsAsRead(category.title);

      // Clear state so it doesn't re-trigger
      if (window.history.replaceState) {
        window.history.replaceState(
          null,
          document.title,
          window.location.pathname
        );
      }
    } else {
      console.log("Category not found for queryOnFromState:", key);
    }
  }, [queryOnFromState, categories]);

  // Function to count unread messages per category
  // const getUnreadCount = (categoryTitle) => {
  //   return messages.filter(
  //     (msg) => msg.query_on === categoryTitle && !msg.is_read
  //   ).length;
  // };

  // Function to render content based on the active tab
  const renderContent = () => {
    return (
      <AdminComments
        activeTab={categories.find((item) => item.name === activeTab)}
      />
    );
  };

  // Get current active category
  const currentCategory = categories.find((cat) => cat.name === activeTab);
  const currentUnreadCount = getUnreadCount(currentCategory?.title);

  // Handle category selection
  const handleCategorySelect = (category) => {
    setActiveTab(category.name);
    markNotificationsAsRead(category.title);
    setShowMobileDropdown(false);
  };

  // Display categories based on screen size and state
  const displayCategories = showAllCategories
    ? categories
    : categories.slice(0, 4);

  return (
    <div>
      <div className="p-2 sm:p-4">
        {/* Mobile Dropdown Categories (visible on small screens) */}
        <div className="block sm:hidden mb-4">
          <div className="relative">
            <button
              onClick={() => setShowMobileDropdown(!showMobileDropdown)}
              className="w-full flex items-center justify-between px-4 py-3 bg-white border border-gray-200 rounded-lg shadow-sm"
            >
              <div className="flex items-center">
                <FaFilter className="mr-2 text-gray-500" />
                <span className="font-medium text-gray-700 truncate">
                  {activeTab}
                </span>
                {currentUnreadCount > 0 && (
                  <span className="ml-2 bg-red-500 text-white rounded-full w-5 h-5 inline-flex items-center justify-center text-xs flex-shrink-0">
                    {currentUnreadCount}
                  </span>
                )}
              </div>
              <FaChevronDown
                className={`transition-transform duration-200 flex-shrink-0 ml-2 ${
                  showMobileDropdown ? "rotate-180" : ""
                }`}
              />
            </button>

            {/* Mobile Dropdown Menu */}
            {showMobileDropdown && (
              <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-64 overflow-y-auto">
                {categories.map((category) => {
                  const unreadCount = getUnreadCount(category.title);
                  return (
                    <button
                      key={category.name}
                      onClick={() => handleCategorySelect(category)}
                      className={`
                        w-full flex items-center justify-between px-4 py-3 text-left border-b border-gray-100 last:border-b-0
                        ${
                          activeTab === category.name
                            ? "bg-blue-50 text-blue-600"
                            : "text-gray-700 hover:bg-gray-50"
                        }
                      `}
                    >
                      <span className="font-medium truncate">
                        {category.name}
                      </span>
                      {unreadCount > 0 && (
                        <span className="bg-red-500 text-white rounded-full w-5 h-5 inline-flex items-center justify-center text-xs flex-shrink-0">
                          {unreadCount}
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* Desktop/Tablet Categories Section (hidden on small screens) */}
        <div className="hidden sm:block mb-4 border-b border-gray-200 pb-4">
          <h3 className="text-gray-700 font-semibold mb-2">Categories:</h3>

          {/* Original horizontal scroll design */}
          <div className="flex overflow-x-auto hide-scrollbar">
            {categories.map((category) => {
              const unreadCount = getUnreadCount(category.title);
              return (
                <button
                  key={category.name}
                  className={`px-4 py-2 whitespace-nowrap mr-2 font-medium rounded-md transition-colors ${
                    activeTab === category.name
                      ? "bg-blue-500 text-white"
                      : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  }`}
                  onClick={() => handleCategorySelect(category)}
                >
                  {category.name}
                  {unreadCount > 0 && (
                    <span className="ml-2 bg-red-500 text-white rounded-full w-5 h-5 inline-flex items-center justify-center text-xs">
                      {unreadCount}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {/* Dynamic Content Section */}
        <div className="bg-blue-50 rounded-lg min-h-[400px] sm:min-h-[600px] shadow-md p-3 sm:p-4 overflow-auto">
          {renderContent()}
        </div>
      </div>

      {/* Overlay to close mobile dropdown when clicking outside */}
      {showMobileDropdown && (
        <div
          className="fixed inset-0 z-40 sm:hidden"
          onClick={() => setShowMobileDropdown(false)}
        />
      )}
    </div>
  );
}

export default CommentsSection;
